module.exports = __webpack_public_path__ + "assets/img/registerBg.c1861634.png";